module.exports = __webpack_public_path__ + "src/assets/img/NK1.83b46394.jpg";